export const LOAD_OR_UPDATE_TOASTER = "LOAD_OR_UPDATE_TOASTER";
export const NOTIFY_TOASTER = "NOTIFY_TOASTER";
export const CREATE_TOASTER = "CREATE_TOASTER";
